import React from "react";
import "./ConstruccionCivil.css"; 
import mecanicaImg from "../assets/images/mecanica.jpg";
import pdfMalla from "../assets/docs/produccion.pdf";
import { FaCogs, FaDownload } from "react-icons/fa";

const MecanicaProduccionIndustrial = () => {
  return (
    <section className="carrera-detalle">
      {/* Banner superior */}
      <div
        className="carrera-hero-modern"
        style={{ backgroundImage: `url(${mecanicaImg})` }}
      >
        <div className="carrera-hero-overlay">
          <h1 className="fw-bold">Mecánica de Producción Industrial</h1>
          <p>
            Formamos profesionales técnicos especializados en procesos de
            producción, mantenimiento y diseño mecánico industrial.
          </p>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="container my-5">
        <div className="row g-4">
  
          <div className="col-lg-8">
            <div className="info-card p-4 shadow-sm rounded-4 bg-white">
              <h3 className="text-primary fw-bold mb-3">
                <FaCogs className="me-2" />
                TÍTULO: PROFESIONAL TÉCNICO EN MECÁNICA DE PRODUCCIÓN INDUSTRIAL
              </h3>

              <h5 className="fw-bold text-primary mt-4">COMPETENCIA GENERAL</h5>
              <p>
                Planificar, coordinar, supervisar y evaluar las labores
                productivas y de mantenimiento mecánico de una planta industrial;
                diseñar, fabricar y reconstruir elementos de máquinas simples y
                matrices, mediante el uso de máquinas herramientas y otras
                técnicas de producción, considerando normas técnicas, seguridad,
                higiene industrial y preservación del medio ambiente.
              </p>

              <h5 className="fw-bold text-primary mt-4">
                CAMPOS DE ACCIÓN EN LOS QUE SE INSERTAN LOS EGRESADOS
              </h5>
              <p>
                El profesional técnico en Mecánica de Producción Industrial
                planifica, coordina, supervisa y evalúa las labores productivas
                dentro de plantas industriales; ejecuta la construcción de
                elementos de máquinas simples y brinda asistencia técnica en
                investigaciones para el perfeccionamiento o fabricación de
                máquinas, herramientas y equipos industriales.
              </p>
              <p>
                Podrá desempeñarse en plantas industriales, talleres,
                maestranzas, factorías e instituciones educativas.
              </p>

              <h5 className="fw-bold text-primary mt-4">PUESTOS DE TRABAJO</h5>
              <ul>
                <li>Supervisor de planta metal-mecánica</li>
                <li>Diseñador de procesos de fabricación</li>
                <li>Operador de máquinas-herramientas</li>
                <li>Gerente de micro o pequeña empresa</li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">
                SALIDA HACIA OTROS ESTUDIOS
              </h5>
              <ul>
                <li>Ingeniería Mecánica</li>
                <li>Ingeniería Industrial</li>
                <li>Ingeniería Metalúrgica</li>
                <li>Ingeniería Mecatrónica</li>
                <li>Ingeniería Química</li>
                <li>Especialización en mantenimiento industrial</li>
              </ul>
            </div>
          </div>

          {/*  Panel lateral */}
          <div className="col-lg-4">
            <div className="sidebar-card p-4 rounded-4 shadow-sm text-center bg-white">
              <img
                src={mecanicaImg}
                alt="Mecánica de Producción Industrial"
                className="img-fluid rounded-3 mb-3"
              />
              <a
                href={pdfMalla}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-download w-100"
              >
                <FaDownload className="me-2" /> Descargar Malla Curricular 2024
                (PDF)
              </a>
              <div className="mt-4 text-start">
                <h6 className="text-primary fw-bold">DURACIÓN</h6>
                <p className="mb-2">
                  Seis semestres equivalentes a tres años académicos.
                </p>
                <h6 className="text-primary fw-bold">TURNOS DE ESTUDIO</h6>
                <p className="mb-0">Diurno - 8:00 a.m. a 1:00 p.m.</p>
                <p className="mb-0">Nocturno - 6:00 p.m. a 10:20 p.m.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MecanicaProduccionIndustrial;
